import React, { useEffect, useState } from "react";
import "./style.css";
import DROWBDOWNLIST from "../DrowbDownList";
import AllDropDownsAHSF from "../AllDropDownsAHSF";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllMarksBySubTaskGuid,
  UpdateAllMarks,
} from "../../Redux/Reducers/MarksManager";
import { GetMarksTableData } from "../../Services/MarksTableManager/GetMarksTableData";
import { retry } from "@reduxjs/toolkit/query";

const MarkesEvaluationTable = (props) => {
  // State variables to store configuration data, marks list, and a refresh flag.
  const [jsonData, setJsonData] = useState();
  const [MarksList, setMarksList] = useState([]);
  const [Refresh, setRefresh] = useState(false);

  // Fetches configuration data from the API.
  const getJsonData = async () => {
    let jsonData = await loadConfig();
    setJsonData(jsonData);
  };

  // Executes `getJsonData` when the component is mounted.
  useEffect(() => {
    getJsonData();
  }, []);

  const dispatch = useDispatch(); // Used to dispatch Redux actions.
  const state = useSelector((state) => {
    return {
      MarksManager: state.MarksManager.MarksManager, // Fetches marks manager state from Redux.
      MarksManagerUpdate: state.MarksManager.MarksManagerUpdate, // Fetches updated marks manager state from Redux.
    };
  });

  // Fetches marks data for the provided task ID.
  const getDataMarks = async () => {
    let data = await GetMarksTableData(props.taskId);
    setMarksList(data.data.result);
  };

  // Executes `getDataMarks` when the component is mounted or when `Refresh` changes.
  useEffect(() => {
    getDataMarks();
  }, [Refresh]);

  // Groups questions by their group name.
  const qustionGroup = () => {
    const marksList = {};
    MarksList.forEach((elem) => {
      if (!marksList[elem.questionGroupName]) {
        marksList[elem.questionGroupName] = [];
      }
      marksList[elem.questionGroupName].push(elem);
    });
    return marksList;
  };

  // Calculates the total marks for a specified column.
  const calculateTotALmARKS = (column) => {
    let total = 0;
    MarksList.map((ele, ind) => {
      total += ele[column] * 100;
    });

    return parseFloat(total.toFixed(2));
  };

  // Updates a specific field for a marks entry and refreshes the table.
  const handleOnBlur = async (fieldName, value, id) => {
    const updatedList = [...MarksList];
    setRefresh(false);

    const targetIndex = updatedList.map((item) => {
      if (item["marksEvaluationGUID"] == id) {
        if (fieldName == "evalYesNo") {
          return {
            ...item,
            [fieldName]: JSON.parse(value), // Parses boolean values.
          };
        } else {
          return {
            ...item,
            [fieldName]: value, // Updates the specified field.
          };
        }
      }
      return item;
    });

    const updated = await dispatch(UpdateAllMarks(targetIndex));
    if (updated.payload) {
      setRefresh(true); // Refreshes the table upon successful update.
    }
  };

  return (
    <>
      <div id="EvaluationInformationId" className="ContinerMarks-section">
        <p className="title">{jsonData?.marksTableTitle}</p>
        <div className="ContinerTableYesNo">
          <table>
            <thead>
              <tr>
                <th>{jsonData?.marksTableStandard}</th>
                <th>{jsonData?.marksTableweight}</th>
                <th>{jsonData?.marksTableMark} / 10</th>
                <th>{jsonData?.TotalTableMark}</th>
                <th>{jsonData?.marksTableComment} </th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(qustionGroup()).map((ele, inds) => {
                return (
                  <>
                    <tr>
                      <th className="PointRow" colSpan="5">
                        {ele}
                      </th>
                    </tr>
                    {qustionGroup()[ele].map((marksOpj, ind) => {
                      return (
                        <tr key={marksOpj.marksEvaluationGUID}>
                          <>
                            <td>{marksOpj.questionName}</td>
                            <td>{marksOpj.questionWeight * 100}</td>
                            <td>
                              <input
                                className={ind + "" + inds}
                                id="inputMarksAndYesNo"
                                defaultValue={marksOpj.evalMark}
                                type="number"
                                onChange={(e) => {
                                  handleOnBlur(
                                    "evalMark",
                                    e.target.value,
                                    marksOpj.marksEvaluationGUID
                                  );
                                }}
                                onBlur={(e) =>
                                  handleOnBlur(
                                    "evalMark",
                                    e.target.value,
                                    marksOpj.marksEvaluationGUID
                                  )
                                }
                                onWheel={(e) => e.target.blur()} // Prevents scrolling from changing input value.
                                disabled={props.disabled}
                              />
                            </td>
                            <td>{parseFloat((marksOpj.total * 100).toFixed(3))}</td>
                            <td>
                              <textarea
                                className="textareaMarksAndYesNo"
                                defaultValue={marksOpj.evalReason}
                                onChange={(e) => {
                                  handleOnBlur(
                                    "evalReason",
                                    e.target.value,
                                    marksOpj.marksEvaluationGUID
                                  );
                                }}
                                onBlur={(e) =>
                                  handleOnBlur(
                                    "evalReason",
                                    e.target.value,
                                    marksOpj.marksEvaluationGUID
                                  )
                                }
                                disabled={props.disabled}
                              />
                            </td>
                          </>
                        </tr>
                      );
                    })}
                  </>
                );
              })}
              {
                <tr className="totalMarkx">
                  <td colSpan={1}>المجموع</td>
                  <td className="RightTotal" colSpan={1}>
                    {calculateTotALmARKS("questionWeight")}
                  </td>
                  <td className="Total"></td>
                  <td className="Total">{calculateTotALmARKS("total")}</td>
                  <td className="LiftTotal"></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default MarkesEvaluationTable;
